module.exports = __webpack_public_path__ + "img/touxiang.c36a8674.png";